class UpdateClientService {
  constructor(httpService) {
    this.http = httpService;
  }
  async execute(clientId, client) {
    return this.http.put(`/client/${clientId}`, client)
  }
}

export default UpdateClientService